<div class="navigation">
  <div>
    @if (showRecent()) {
      <div class="group">
        <div class="header"><lucide-icon name="handshake" size="16"></lucide-icon> <span>Deals</span></div>
        <ts-divider spacing="none"></ts-divider>
      </div>
      <ts-tree-menu
        title="Recent Deals"
        titleIcon="ts_redo"
        [items]="(recentDeals$ | async) ?? []"
        [actions]="[]"
        (action)="onActionClicked($event)"
        [activeNodeFn]="checkViewIsActive"
        [loading]="loading"
        [extraMarginLeft]="true"
        [delegateLeafClickFn]="delegateLeafClickFn.bind(this)"
      >
      </ts-tree-menu>
    }
    <ts-tree-menu
      title="Views"
      [items]="sidebarItems"
      [actions]="tsTreeActions"
      (action)="onActionClicked($event)"
      [activeNodeFn]="checkViewIsActive"
      [loading]="loading"
      [allowNewItems]="canManagePipeline()"
      [delegateLeafClickFn]="delegateLeafClickFn.bind(this)"
    >
    </ts-tree-menu>
  </div>
</div>
